import React, {useRef, useEffect, useState} from 'react';
import useWindow from './useWindow';
import VirtualReality from './VirtualReality';

export default function VideoStream({ interrupt, stream, displayShutdownOverlay, displayEmergencyOverlay, activityTimer, mechanicalState }) {

    const videoTagRef = useRef();
    const divTagRef = useRef();
    const [coutdown, setCoutdown] = useState(null);

    function requestFullscreen() {
        divTagRef.current.requestFullscreen();
    }

    useEffect(() => {
        function refreshTimer() {
            setCoutdown(Math.ceil(10.0 - (Date.now() - activityTimer.startTimeRef.current) / 1000.0));
        }

        const intervalId = window.setInterval(refreshTimer, 100);
        return () => {
            window.clearInterval(intervalId);
        }
    });

    const shutdownOverlay = <div className="shutdownOverlay" />
    const emergencyOverlay = <div className="emergencyOverlay" />
    const activityOverlay = <div className="activityOverlay" />
    
    const frontWheelsAngle = mechanicalState.frontWheelsAngle;
    const wheelMode = mechanicalState.wheelMode;
    const gear = mechanicalState.gear;
    
    const augmentedReality = <VirtualReality driveMode={wheelMode} wheel_angle={frontWheelsAngle} polar={2.39} zoom={7} position={[-2, -0.5, -2]} />
    const augmentedRealityBackward = <VirtualReality driveMode={wheelMode} wheel_angle={frontWheelsAngle*(-1)} polar={2.33} zoom={6.5} position={[0.4, -0.5, -2]} />

    const activityTimerCountdown = <div className="activityCountdown">Lack of activity, emergency state in {coutdown} seconds</div>;
    const displayActivityTimer = activityTimer.level > 1;

    const shutdownTimerCountdown = <div className="activityCountdown">Vehicle is shutting down in less than 10 seconds</div>;

    const children = 
    <div>
        <div className="videoContainer" ref={divTagRef}>
            <video className="liveStreamTest" id="video" autoPlay playsInline muted="muted" ref={videoTagRef} />
            <div> {(stream.id === 'front') && (gear === 1) && augmentedReality} </div>
            <div> {(stream.id === 'back') && (gear === 3) && augmentedRealityBackward} </div>
            {displayEmergencyOverlay && emergencyOverlay}
            {displayActivityTimer && activityTimerCountdown}
            {displayActivityTimer && activityOverlay}
            {displayShutdownOverlay && shutdownOverlay}
            {displayShutdownOverlay && shutdownTimerCountdown}
            
        </div>
        <button className="btn btn-outline-primary btnfullscreen" onClick={requestFullscreen}>Go fullscreen</button>
    </div>;
    const features = {width: 1280, height: 720};

    const { component } = useWindow({ title: `video-${stream.id}`, features, onUnload: interrupt, onWindowOpenUser, children});
    
    function onWindowOpenUser(_event) {
        setTimeout(function(){
            const videoTag = videoTagRef.current;
            videoTag.srcObject = stream;
            const playPromise = videoTag.play();
            if (playPromise !== undefined) {
                playPromise.then(() => {
                    // Automatic playback started!
                    // Show playing UI.
                }).catch(error => {
                    // Automatic playback failed.
                    // Show paused UI.
                });
            }
        }, 100);        
    }

    return component;
}
